module.exports = __webpack_public_path__ + "static/media/bonus.b567164e.png";